module.exports = "/assets/data/e74e8e57501fc365aee19613a515efb5-MK8.data.json";